import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const InputWrapper = ({ className, width, children, bgcolor }) => {
  return (
    <Wrapper className={className} width={width} bgcolor={bgcolor}>
      {children}
    </Wrapper>
  );
};

export default InputWrapper;

InputWrapper.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  children: PropTypes.node.isRequired,
  bgcolor: PropTypes.string.isRequired
};

InputWrapper.defaultProps = {
  className: '',
  width: ''
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: ${props => (props.width ? props.width : '40%')};
  margin-bottom: 2em;

  @media (max-width: 1100px) {
    width: 70%;
  }

  @media (max-width: 700px) {
    width: 100%;
  }

  &.descriptionBox {
    width: 90%;

    @media (max-width: 1100px) {
      width: 70%;
    }

    @media (max-width: 700px) {
      width: 100%;
    }
  }

  &.houseBox {
    margin-right: auto;
    margin-left: 5%;

    @media (max-width: 1100px) {
      margin: 0;
      margin-bottom: 2em;
    }
  }

  & select {
    /* styling */
    background-color: white;
    border: thin solid blue;
    border-radius: 4px;
    display: inline-block;
    font: inherit;
    line-height: 1.5em;

    /* reset */

    margin: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: linear-gradient(45deg, transparent 50%, black 50%),
      linear-gradient(135deg, black 50%, transparent 50%),
      linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0));
    background-position: calc(100% - 20px) calc(1.7em + 2px),
      calc(100% - 15px) calc(1.7em + 2px), calc(100% - 2.5em) 1.25em;
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
    background-color: ${props => props.bgcolor};
    border: none;
    border-radius: 8px;
    padding: 1.25em 2em 1.25em 1.25em;
    font-size: 1em;
    box-sizing: border-box;
    transition: all 0.1s linear;

    &#date {
      width: 100%;
    }

    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    }
  }

  & input,
  textarea {
    background-color: ${props => props.bgcolor};
    border-radius: 8px;
    padding: 1.25em;
    font-size: 0.92em;
    box-sizing: border-box;
    transition: all 0.1s linear;
    font-family: inherit;
    border: none;

    &#date {
      width: 100%;
    }

    &:focus {
      outline: none;
      box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    }
  }
`;
